import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Stack} from 'shells/layout/stack/stack';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {Body} from 'shells/typography/body';

export function CancelledPlanBanner() {
    return (
        <div className='mb-12'>
            <FlashBanner type='info' hasBorder={true}>
                <Stack isHorizontal={true} spacing={2} isFullWidth={true}>
                    <Body color='blue-dk'>Your plan has been cancelled</Body>
                    <PopoverInfo
                        info='Your subscriptions have been cancelled and are no longer active. You will maintain access until the end of your billing cycle. Please contact support if you believe this is a mistake.'
                        size={16}
                        variant='blue'
                    />
                </Stack>
            </FlashBanner>
        </div>
    );
}
